import React from 'react';
import { UilTimes } from '@iconscout/react-unicons'
import './customModal.scss';

/**
 * 
 * @param {{title: string, close: boolean, onClose: callback, style: object, height: number, width: number}} props 
 * @returns 
 */
export default function CustomModal(props) {
  return (
    <div className={`csModalBackdrop ${props?.className || ''}`} style={{ ...props?.style }}>
      <div
        className={`csModalContent scroller ${props?.contentClassName || ''}`}
        style={{ height: props.height, width: props.width, padding: 10, ...props?.style, ...props?.contentStyle }}
      >
        {(props.title || props.close) && <div className="csModalTitleContainer" style={{ borderBottom: `${(!props.title && !props.close)?"none":"1px solid #D7D7D7"}` }}>
          <div className="csModalTitle">
            {props.title && (
              <h1>{props.title}</h1>
            )}
          </div>
          {props.close && (
            <button type="button" onClick={() => props.onClose()} className='closeBtn' disabled={props.closeDisabled}>
              <UilTimes className="csModalCloseButton" size={20} />
            </button>
          )}
        </div>}
        <div className={`csModalBody scroller ${props?.bodyClassName || ''}`} style={{ overflowY: 'auto', ...(props.fullHeight ? { height: '100%' } : {}), ...props?.bodyStyle }}>
          {props.children}
        </div>
      </div>
    </div>
  );
}
